import "./SinglePostTemplate.module.css"
import Header from "@/reusable_sections/Header"
import Article from "./sections/Article"
import Footer from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <Header />
      <Article />
      <Footer />
    </div>
  )
}
